import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BranchService } from '@api/services/branch.service';
import { DealerService } from '@api/services/dealer.service';
import { StockSetService } from '@api/services/stock-set.service';
import { SmartyGptModule } from '@feature/smart-reports-core/components/smarty-gpt/smarty-gpt.module';
import { ProfileService } from '@modules/security/profile/services/profile.service';
import { RoleService } from '@modules/security/profile/services/role.service';
import { SmartyModule } from '@modules/smarty.module';
import { ValidatorsModule } from '@modules/validators/validators.module';
import { LayoutModule } from '../../layout/layout.module';
import { PageComponent } from './page.component';
import { PageRoutingModule } from './page.routing';

@NgModule({
	declarations: [PageComponent],
	imports: [RouterModule, PageRoutingModule, SmartyModule, LayoutModule, ValidatorsModule, SmartyGptModule],
	providers: [RoleService, DealerService, ProfileService, BranchService, StockSetService],
})
export class PageModule {
	constructor() {
		console.log('Module - Page init.');
	}
}
